import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PopoverController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

import { ChatService } from 'src/app/services/chat.service';
import { ConexionService } from 'src/app/services/conexion.service';
import { PerfilPopoverComponent } from '../perfil-popover/perfil-popover.component';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-foto-perfil',
  templateUrl: './foto-perfil.component.html',
  styleUrls: ['./foto-perfil.component.scss'],
})
export class FotoPerfilComponent implements OnInit {

  loading: HTMLIonLoadingElement;
  imagenSeleccionada = 'assets/perfilDefault.png';

  idAdmin: any;
  idAdminCanal: any;
  idAgente: any;
  classUser: any;
  enChats: any;

  mensaje = '';
  estadoConexion = 'online';
  colorConexion = true;
  nombre = '';
  apellido = '';
  rol: any;

  private activeToast: HTMLIonToastElement | null;

  constructor(
    public chat: ChatService,
    private toastController: ToastController,
    private popoverController: PopoverController,
    private conexion: ConexionService,
    private storage: Storage,
    private router: Router
  ) {
    this.activeToast = null;
  }

  ngOnInit() {
    this.seeToast();

    this.classUser = new ValidarToken(this.storage);

    this.storage.get('usuario').then((usuario) => {
      // console.log(usuario, 'este es el usuario');
      this.nombre = usuario.nombre;
      this.apellido = usuario.apellido;
      this.idAdmin = usuario.idAdmin;
      this.idAgente = usuario.idAgente;
      this.rol = usuario.rol;
      this.idAdminCanal = usuario.idAdminCanal;
    }).then(() => {
      this.mostrarImagen();
    });

    this.enChats = this.router.url.includes('chats') || this.router.url.includes('chats-');
  }

  seeToast() {
    this.conexion.estadoConexion$.subscribe(async (estaConectado) => {
      this.estadoConexion = estaConectado ? 'online' : 'offline';
      this.colorConexion = !!estaConectado;

      if (!estaConectado) {
        // OFFLINE → toast fijo si no existe ya
        if (!this.activeToast) {
          const offlineToast = await this.toastController.create({
            message: 'Se ha perdido la conexión a internet',
            duration: 0,
            color: 'danger',
            position: 'bottom',
          });
          this.activeToast = offlineToast;
          await offlineToast.present();

          // limpiar referencia si lo cierran manualmente
          offlineToast.onDidDismiss().then(() => {
            if (this.activeToast === offlineToast) {
              this.activeToast = null;
            }
          });
        }
        this.mensaje = 'Sin Conexión a Internet';
        return;
      }

      // ONLINE → cerrar el toast fijo (si estaba) y luego mostrar “En línea”
      if (this.activeToast) {
        await this.activeToast.dismiss(); // cierra el OFFLINE fijo
        this.activeToast = null;
      }

      const onlineToast = await this.toastController.create({
        message: 'En línea',
        duration: 2000,
        color: 'success',
        position: 'bottom'
      });
      this.activeToast = onlineToast;     // opcional: por consistencia
      await onlineToast.present();
      onlineToast.onDidDismiss().then(() => {
        if (this.activeToast === onlineToast) {
          this.activeToast = null;
        }
      });

      this.mensaje = 'Con Conexión a Internet';
    });
  }

  mostrarImagen() {
    this.chat.getFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token)
      .subscribe((res: any) => {
        // console.log('mostrarImagen', res);

        if (res.status === 'succeess') {
          this.imagenSeleccionada = res.foto;
        } else {
          this.imagenSeleccionada = 'assets/perfilDefault.png';
        }
      });
  }

  async perfilPopover(event) {
    const popover = await this.popoverController.create({
      component: PerfilPopoverComponent,
      event,
      translucent: true,
      mode: 'ios'
    });
    await popover.present();

    const { data } = await popover.onDidDismiss(); // Captura la imagen nueva
    if (data) {
      this.imagenSeleccionada = data;
    }
  }

}
